import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-horizontal" }
const _hoisted_2 = { class: "table-responsive p-0" }
const _hoisted_3 = { class: "table table-bordered text-nowrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Persona"),
    /*#__PURE__*/_createElementVNode("th", null, "Package"),
    /*#__PURE__*/_createElementVNode("th", null, "Price"),
    /*#__PURE__*/_createElementVNode("th", null, "Credit"),
    /*#__PURE__*/_createElementVNode("th", null, "Rate"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  style: {"color":"#5cb85c"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-square" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "card-footer" }
const _hoisted_9 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col mx-auto",
    label: (_ctx.model.id ? 'Clone' : 'Create') + ' Prototype Item'
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createVNode(_component_app_form_row, { label: "Name" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              modelValue: _ctx.model.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event)),
              validations: _ctx.v$.name
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Rfm Group" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              options: _ctx.rfmGroupOptions,
              modelValue: _ctx.model.rfmGroupId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.rfmGroupId) = $event)),
              modelModifiers: { number: true },
              onChange: _ctx.fetch
            }, null, 8, ["options", "modelValue", "onChange"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.list, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  role: "row",
                  key: item.index
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.personaName), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_select, {
                      options: _ctx.iapOptions,
                      modelValue: item.iapId,
                      "onUpdate:modelValue": ($event: any) => ((item.iapId) = $event),
                      modelModifiers: { number: true },
                      onChange: ($event: any) => (_ctx.actions.selectIAP($event.target.value, item))
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.price), 1),
                  _createElementVNode("td", null, _toDisplayString(item.credit), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_input, {
                      type: "number",
                      modelValue: item.rate,
                      "onUpdate:modelValue": ($event: any) => ((item.rate) = $event),
                      modelModifiers: { number: true },
                      onChange: ($event: any) => (_ctx.actions.changeRate(item)),
                      style: {"min-width":"55px"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _createElementVNode("td", null, [
                    (item.canAdd)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_5, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_button, {
                      name: "",
                      theme: "success",
                      icon: "fa-redo",
                      onClick: _withModifiers(($event: any) => (_ctx.actions.clearRow(item)), ["prevent"])
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_app_button, {
              name: "Create",
              theme: "info",
              icon: "fa-save",
              disabled: !_ctx.validateModel,
              onClick: _withModifiers(_ctx.actions.create, ["prevent"])
            }, null, 8, ["disabled", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["label"]))
}